import { useNavigate, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Search, LayoutDashboard, Database, ShieldQuestion, Bell } from "lucide-react";

const NAV = [
  { to: "/business-intelligence", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/business-intelligence/cambiamenti", label: "Cambiamenti", icon: Bell },
  { to: "/business-intelligence/fonti", label: "Fonti dati", icon: Database },
];

export default function AbiShell({ children }) {
  const nav = useNavigate();
  const loc = useLocation();
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <div className="border-b border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center gap-1">
          <div className="flex items-center gap-2 py-3 pr-6 mr-2 border-r border-slate-200">
            <div className="h-8 w-8 rounded-lg bg-violet-100 text-violet-700 flex items-center justify-center">
              <ShieldQuestion className="h-4 w-4" />
            </div>
            <span className="font-heading font-semibold text-slate-800 text-sm">Business Intelligence</span>
          </div>
          {NAV.map((n) => {
            const active = n.exact ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
            return (
              <button key={n.to} onClick={() => nav(n.to)} data-testid={`abi-nav-${n.label}`}
                className={`flex items-center gap-1.5 px-3 py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${active ? "border-violet-600 text-violet-700" : "border-transparent text-slate-500 hover:text-slate-700"}`}>
                <n.icon className="h-4 w-4" /> {n.label}
              </button>
            );
          })}
        </div>
      </div>
      {children}
    </div>
  );
}

export { Search };
